import BaseClient from "../baseClient";
import GeneralConfigurationResponse from "./generalConfigurationResponse";
import SearchApiConfigurationResponse from "./searchApiConfigurationResponse";
import RecaptchaRequest from "../recaptchaRequest";

export default class ConfigurationClient extends BaseClient {

    public async fetchSearchApiConfigurationAsync() : Promise<SearchApiConfigurationResponse> {
        
        const recaptchaToken = await this.recaptchaChallengeAsync('configuration_os_api')

        const requestBody: RecaptchaRequest =
        {
            recaptchaToken: recaptchaToken
        }

        const response = await this.makeRequestAsync({
            controller: 'configuration',
            action: 'os-api',
            method: 'post',
            body: requestBody
        });
        return response as SearchApiConfigurationResponse;
    }


    /**
     * Gets the general configuration from the server.
     * @returns The configuration response object.
     */
    public async getGeneralConfigurationAsync() : Promise<GeneralConfigurationResponse> {
        const response = await this.makeRequestAsync({controller: 'configuration', action: 'general', method: 'get'});
        return response as GeneralConfigurationResponse;
    }

}
